import React from "react";
import LeadGeneartionList from "../LeadGenerationList";

const CPLeadList = () => {
  return (
    <>
      <LeadGeneartionList userType={"CP"} url={"/cp-lead-generation"} />
    </>
  );
};

export default CPLeadList;
